var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "custom-repeat" } },
    [
      _c(
        "a-modal",
        {
          attrs: {
            visible: true,
            cancelText: _vm.$t("calendar.cancel"),
            okText: "$t('calendar.save')",
            centered: "",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("calendar.customRepeat"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "recurrence" },
            [
              _c("div", { staticClass: "recurrence-label" }, [
                _vm._v(_vm._s(_vm.$t("calendar.recurrenceFrequency"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.recurrenceNumber,
                    expression: "recurrenceNumber",
                  },
                ],
                staticClass: "input-number",
                attrs: { type: "number" },
                domProps: { value: _vm.recurrenceNumber },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.recurrenceNumber = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { "show-search": "" },
                  model: {
                    value: _vm.recurrenceDate,
                    callback: function ($$v) {
                      _vm.recurrenceDate = $$v
                    },
                    expression: "recurrenceDate",
                  },
                },
                _vm._l(_vm.repeatTimes, function (repeatTime, index) {
                  return _c(
                    "a-select-option",
                    { key: index, attrs: { value: repeatTime.value } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(repeatTime.label) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.recurrenceDate === "weeks"
            ? _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _c("div", { staticStyle: { "font-size": "14px" } }, [
                  _vm._v(_vm._s(_vm.$t("calendar.repeatDays"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  _vm._l(_vm.days, function (day) {
                    return _c(
                      "div",
                      {
                        staticClass: "repeat-days",
                        class: _vm.isSelected(day) ? "active" : "",
                        on: {
                          click: function ($event) {
                            return _vm.addRepeatDay(day)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(day.label) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.recurrenceDate === "months"
            ? _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { "show-search": "" },
                      model: {
                        value: _vm.recurrenceMonth,
                        callback: function ($$v) {
                          _vm.recurrenceMonth = $$v
                        },
                        expression: "recurrenceMonth",
                      },
                    },
                    _vm._l(_vm.repeatMonths, function (repeatMonth, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: repeatMonth.value } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(repeatMonth.label) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "end-date-label" }, [
                _vm._v(_vm._s(_vm.$t("calendar.end"))),
              ]),
              _vm._v(" "),
              _c(
                "a-radio-group",
                {
                  staticClass: "radio-btns",
                  model: {
                    value: _vm.selectEndDateType,
                    callback: function ($$v) {
                      _vm.selectEndDateType = $$v
                    },
                    expression: "selectEndDateType",
                  },
                },
                [
                  _c(
                    "a-radio",
                    { staticClass: "radio-btn", attrs: { value: "any" } },
                    [_vm._v(_vm._s(_vm.$t("calendar.never")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-radio",
                    { staticClass: "radio-btn", attrs: { value: "select" } },
                    [
                      _c("div", { staticStyle: { "margin-right": "10px" } }, [
                        _vm._v(_vm._s(_vm.$t("calendar.thisDate"))),
                      ]),
                      _vm._v(" "),
                      _c("a-date-picker", {
                        attrs: { disabled: _vm.selectEndDateType !== "select" },
                        model: {
                          value: _vm.endDateSelect,
                          callback: function ($$v) {
                            _vm.endDateSelect = $$v
                          },
                          expression: "endDateSelect",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-radio",
                    {
                      staticClass: "radio-btn",
                      attrs: { value: "recurrence" },
                    },
                    [
                      _c("div", { staticStyle: { "margin-right": "10px" } }, [
                        _vm._v(_vm._s(_vm.$t("calendar.recurrenceCount"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.endDateRecurrence,
                            expression: "endDateRecurrence",
                          },
                        ],
                        staticClass: "input-number",
                        attrs: {
                          type: "number",
                          disabled: _vm.selectEndDateType !== "recurrence",
                        },
                        domProps: { value: _vm.endDateRecurrence },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.endDateRecurrence = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-btns" }, [
            _c(
              "span",
              {
                staticClass: "footer-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("calendar.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "footer-btn",
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("calendar.save")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }